import dayjs from 'dayjs';

export const compareId = (value1: string, arr: Array<any>) => {
  const res = arr.find(item => {
    return value1 === item.clinicId;
  });
  return res;
};
